import { useMemo } from 'react';
import { useSelector } from '@client/hooks/redux.hooks';
import { getMapBounds } from '@client/selectors/features/map';

export const useFilterLocation = () => {
  const formBounds = useSelector(getMapBounds);

  const filterLocation = useMemo(() => {
    if (!formBounds) {
      return { aroundLatLngViaIP: true, hitsPerPage: 10 };
    }

    // Does it cross the international date line?
    // If it does, draw two bounding boxes, where each has an edge at the date line
    if (formBounds.nw.lng > formBounds.ne.lng) {
      return {
        insideBoundingBox: [
          [
            formBounds.ne.lat,
            179,
            formBounds.sw.lat,
            formBounds.sw.lng,
          ],
          [
            formBounds.ne.lat,
            formBounds.ne.lng,
            formBounds.sw.lat,
            -179,
          ],
        ],
      };
    }

    return { insideBoundingBox: [[formBounds.ne.lat, formBounds.ne.lng, formBounds.sw.lat, formBounds.sw.lng]] };
  }, [formBounds]);

  return filterLocation;
};
